import OurNatureImpactPage from './ourNatureImpactPage';
export default OurNatureImpactPage;